// extracted by mini-css-extract-plugin
module.exports = {"ant-spin-container":"Navigation_ant-spin-container__LvDjF","navigation":"Navigation_navigation__1EXoy"};